import $ from 'jquery';
import _ from 'underscore';
import * as wishlistService from './wishlistService';

var selectors = {
    wishlistButton: '.js-wishlist-button',
    wishlistIconClass: 'wishlist-icon',
    wishlistIconActiveClass: 'wishlist-icon--active',
    wishlistIconInactiveClass: 'wishlist-icon--inactive'
};

export default function WishlistButtonView() {
    _.bindAll(this, 'onClick');

    this.$container = $('body');
    this.inRequestElements = [];
    this.initialize();
}

WishlistButtonView.prototype = {

    initialize: function () {
        this.$container.on('click touchend', selectors.wishlistButton, this.onClick);
    },

    destroy: function () {
        this.$container.off('click touchend', this.onClick);
    },

    onClick: function (event) {
        event.preventDefault();

        var $clickedEl = $(event.currentTarget);

        // jquery caches the attribute value if retrieved with .data()
        var sku = $clickedEl.attr('data-sku');
        var $iconEl = this.getIconElement($clickedEl);
        var action;
        var promise;

        if (this.checkInProgress($iconEl)) {
            return;
        }

        if (this.isActive($iconEl)) {
            action = 'remove';
            promise = wishlistService.remove(sku);
        } else {
            action = 'add';
            promise = wishlistService.add(sku);
        }

        promise.done(_.bind(this.onSuccess, this, sku, action));
        promise.fail(_.bind(this.onFail, this, $iconEl));
        promise.always(_.bind(this.onRequestFinish, this, $iconEl));

        // for better UX set the new state now and validate the response later
        this.toggleButtonState($iconEl);
    },

    // check what was clicked, button with icon inside or icon directly
    getIconElement: function ($clickedEl) {
        var result;

        if ($clickedEl.hasClass(selectors.wishlistIconClass)) {
            result = $clickedEl;
        } else {
            result = $clickedEl.find('.' + selectors.wishlistIconClass);
        }

        return result;
    },

    isActive: function ($el) {
        return $el.hasClass(selectors.wishlistIconActiveClass);
    },

    checkInProgress: function ($el) {
        var el = $el[0];
        var index = this.inRequestElements.indexOf(el);

        if (~index) {
            return true;
        }

        this.inRequestElements.push(el);

        return false;
    },

    onRequestFinish: function ($el) {
        var el = $el[0];
        var index = this.inRequestElements.indexOf(el);

        if (~index) {
            this.inRequestElements.splice(index, 1);
        }
    },

    onSuccess: function (sku, action) {
        if (action === 'add') {
            $.publish('added.wishlist', { sku: sku });

        } else if (action === 'remove') {
            $.publish('removed.wishlist', { sku: sku });
        }
    },

    onFail: function ($el) {
        this.toggleButtonState($el);
    },

    toggleButtonState: function ($el) {
        if (this.isActive($el)) {
            $el.removeClass(selectors.wishlistIconActiveClass);
            $el.addClass(selectors.wishlistIconInactiveClass);
        } else {
            $el.addClass(selectors.wishlistIconActiveClass);
            $el.removeClass(selectors.wishlistIconInactiveClass);
        }
    }

};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/wishlist/buttonView.js
 **/